export default {
  noMessagesLabel: 'No Messages'
};
